/**
 * Value for controlled MUI `type="number"` fields: preserve empty input (no forced 0),
 * and avoid "02" when replacing a leading 0 by typing a new digit.
 */
export function numberInputDisplayValue(v) {
  if (v === "" || v === null || v === undefined) return "";
  if (typeof v === "number") {
    if (Number.isNaN(v)) return "";
    return v;
  }
  const n = Number(v);
  if (Number.isNaN(n)) return "";
  return n;
}
